<script>
const BLOCK_SELECTOR = 'btn-toolbar';

const concat = (...classList) => classList.filter(Boolean).join(' ');

export default {
  name: 'BtnToolbar',
  props: {
    noWrap: { type: Boolean, default: false },
    fullWidth: { type: Boolean, default: false },
    fullWidthEqual: { type: Boolean, default: false },
    centered: { type: Boolean, default: false },
    // centeredUntilXxxs: { type: Boolean, default: false },
    // centeredUntilXxs: { type: Boolean, default: false },
    // centeredUntilXs: { type: Boolean, default: false },
    // centeredUntilS: { type: Boolean, default: false },
    // centeredUntilM: { type: Boolean, default: false },
    // centeredUntilL: { type: Boolean, default: false },
    // centeredUntilXl: { type: Boolean, default: false },
    // centeredUntilXxl: { type: Boolean, default: false },
    // centeredUntilXxxl: { type: Boolean, default: false },
    vertical: { type: Boolean, default: false },
    // verticalUntilXxxs: { type: Boolean, default: false },
    // verticalUntilXxs: { type: Boolean, default: false },
    verticalUntilXs: { type: Boolean, default: false },
    // verticalUntilS: { type: Boolean, default: false },
    // verticalUntilM: { type: Boolean, default: false },
    // verticalUntilL: { type: Boolean, default: false },
    // verticalUntilXl: { type: Boolean, default: false },
    // verticalUntilXxl: { type: Boolean, default: false },
    // verticalUntilXxxl: { type: Boolean, default: false },
  },
  render(h) {
    // Append 'btn-toolbar__item' class
    (this.$slots.default || []).forEach(vnode => {
      vnode.data = {
        ...vnode.data,
        staticClass: concat(
          vnode.data && vnode.data.staticClass,
          `${BLOCK_SELECTOR}__item`
        ),
      };
    });

    return h(
      'div',
      {
        class: [
          BLOCK_SELECTOR,
          {
            [`${BLOCK_SELECTOR}--no-wrap`]: this.noWrap,
            [`${BLOCK_SELECTOR}--full-width`]: this.fullWidth,
            [`${BLOCK_SELECTOR}--full-width-equal`]: this.fullWidthEqual,
            // Centered
            [`${BLOCK_SELECTOR}--centered`]: this.centered,
            // [`${BLOCK_SELECTOR}--centered-until-xxxs`]: this.centeredUntilXxxs,
            // [`${BLOCK_SELECTOR}--centered-until-xxs`]: this.centeredUntilXxs,
            // [`${BLOCK_SELECTOR}--centered-until-xs`]: this.centeredUntilXs,
            // [`${BLOCK_SELECTOR}--centered-until-s`]: this.centeredUntilS,
            // [`${BLOCK_SELECTOR}--centered-until-m`]: this.centeredUntilM,
            // [`${BLOCK_SELECTOR}--centered-until-l`]: this.centeredUntilL,
            // [`${BLOCK_SELECTOR}--centered-until-xl`]: this.centeredUntilXl,
            // [`${BLOCK_SELECTOR}--centered-until-xxl`]: this.centeredUntilXxl,
            // [`${BLOCK_SELECTOR}--centered-until-xxxl`]: this.centeredUntilXxxl,
            // Vertical
            [`${BLOCK_SELECTOR}--vertical`]: this.vertical,
            // [`${BLOCK_SELECTOR}--vertical-until-xxxs`]: this.verticalUntilXxxs,
            // [`${BLOCK_SELECTOR}--vertical-until-xxs`]: this.verticalUntilXxs,
            [`${BLOCK_SELECTOR}--vertical-until-xs`]: this.verticalUntilXs,
            // [`${BLOCK_SELECTOR}--vertical-until-s`]: this.verticalUntilS,
            // [`${BLOCK_SELECTOR}--vertical-until-m`]: this.verticalUntilM,
            // [`${BLOCK_SELECTOR}--vertical-until-l`]: this.verticalUntilL,
            // [`${BLOCK_SELECTOR}--vertical-until-xl`]: this.verticalUntilXl,
            // [`${BLOCK_SELECTOR}--vertical-until-xxl`]: this.verticalUntilXxl,
            // [`${BLOCK_SELECTOR}--vertical-until-xxxl`]: this.verticalUntilXxxl,
          },
        ],
      },
      this.$slots.default
    );
  },
};
</script>
